import { JORDAN_DROPS_HOSTNAME } from "../constants";

/**
 * @name checkIsJordanDropsHost
 * @description Function to determine if the current page is being rendered on the Jordan Drops
 * domain (including subdomains such as uat.*), so consent UI can render the Jordan Drops visual
 * variant.
 * @returns {boolean}
 */
export const checkIsJordanDropsHost = () => {
  var _window$location$host;
  return typeof window !== 'undefined' && (window.location.hostname === JORDAN_DROPS_HOSTNAME || !!((_window$location$host = window.location.hostname) !== null && _window$location$host !== void 0 && _window$location$host.endsWith(`.${JORDAN_DROPS_HOSTNAME}`)));
};